// components/CheckboxField.js
import React from 'react';

const CheckboxField = ({ label, checked, onChange, required, error }) => {
  return (
    <>
      <div className="checkbox-container">
        <label>
          <input 
            type="checkbox" 
            checked={checked} // Controlled checkbox
            onChange={onChange} // Handle change via props
          />
          {label}
          {required && <span className="required" style={{ marginLeft: "5px" }}>*</span>}
        </label>
      </div>
      {error && <p className="error-text" style={{ marginTop: "-20px" }}>{error}</p>} {/* Display error message */}
    </>
  );
};

export default CheckboxField;
